<template>
    <v-main style="background:#e1e1e1;">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" style="flex-direction: column">
          <img alt="Vue logo" src="../../assets/logo.png" class="logo">
          <v-col cols="12" sm="8" md="4">
            <v-card flat class="elevation-1">
              <v-toolbar dense dark flat color="black">
                <v-icon>mdi-account-circle</v-icon> <span class="ml-2 ellipsify">Acesso</span>
                <v-spacer></v-spacer>
                <v-btn small depressed color="red darken-2" v-if="$store.getters.logged">sair</v-btn>
              </v-toolbar>
              <v-card-text>
                <v-form>
                    <v-text-field filled v-model="email" label="E-mail" autocomplete="email" xhide-details name="email" placeholder=" " prepend-inner-icon="mdi-email" type="text"></v-text-field>
                    <v-text-field filled hide-details v-model="password" id="password" autocomplete="current-password" xhide-details label="Senha" placeholder=" " name="password" prepend-inner-icon="mdi-lock" type="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-btn block depressed tile color="success" @click="userLogin()">Entrar</v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            password: ""
        }
    },
    mounted () {
        if (this.$store.getters.logged) {
            this.$router.push('/admin');
        }
    },
    methods: {
        userLogin() {
          const payload = {
              email: this.email,
              password: this.password
          }

          this.$api
          .post('/user.login', payload)
          .then(response => {
            if (response.data.id) {
                this.$store.dispatch('login', response.data);
                this.$router.push('/admin');
            }
          });
        }
    },
}
</script>

<style>
.logo {
  margin-bottom: 20px;
  width: 180px;
}
</style>